import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Stack} from '@travel-frontend/ui-components';

type Props = {
  children: React.ReactNode;
  isOneBadge?: boolean;
};
export const Target = styled(Stack)<Props>(
  ({theme, isOneBadge}) => css`
    min-width: 96px;
    height: 83px;
    position: relative;

    z-index: ${theme.stacking.zIndexControls};

    ${isOneBadge &&
    css`
      max-width: 328px;
    `}

    ${theme.respondTo(
      'lg',
      css`
        && {
          max-width: 328px;
          height: 127px;
          min-width: 140px;
        }
      `
    )}
    ${theme.respondTo(
      'sm',
      css`
        max-width: 130px;
        height: 95px;
      `
    )}
  `
);
